module.exports = __webpack_public_path__ + "static/img/logo-website.216dcec9.png";